import "./index.scss";
export const InnerPageLeft = ({children}) => {
    return(
        <div className="inner-page-left">
            {children}
        </div>
    )
}